/**
 * Stytch Provider Component
 * Initializes and provides Stytch SDK to the application
 */

import React, { useEffect, useState } from 'react';
import { StytchProvider as BaseStytchProvider } from '@stytch/react';
import { validateStytchConfig } from '../config/stytch';
import { getStytchClient } from '../services/auth/stytchClient';
import { PageLoader } from '../shared/components/ui/Loader';

interface StytchProviderProps {
  children: React.ReactNode;
}

export const StytchProvider: React.FC<StytchProviderProps> = ({ children }) => {
  const [isConfigValid, setIsConfigValid] = useState<boolean | null>(null);

  // Get the singleton Stytch client instance
  const stytchClient = getStytchClient();

  useEffect(() => {
    // Validate Stytch configuration on mount
    const valid = validateStytchConfig();
    setIsConfigValid(valid);
    
    // Silent when intentionally disabled
  }, []);

  // Show loader while checking configuration
  if (isConfigValid === null) {
    return <PageLoader />;
  }

  // If configuration is invalid or client creation failed, render children without Stytch
  if (!isConfigValid || !stytchClient) {
    return <>{children}</>;
  }

  return (
    <BaseStytchProvider stytch={stytchClient}>
      {children}
    </BaseStytchProvider>
  );
};